
import '@/assets/images/kow-map-no-city.png'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MapImage',
  emits: [ 'load' ],
})
